module.exports = __webpack_public_path__ + "static/img/Icon-Offer claimed.674b2057.svg";